import BaseService from "../../../services/geral/BaseService";

const base = "simulacao-servicos";

export class ServicosService extends BaseService {
    constructor() {
        super(base);
    }

    listarOpcoesServicosPorTipo = (tipo) => {
        return super.httpGet(`/${base}/ListarOpcoesServicosPorTipo/${tipo}`);
    }

    gerarSimulacao = (simulacao) => {
        return super.httpPost(`/${base}`, simulacao, false);
    }

    enviarEmailSimulacao(data){
        return super.httpPost(`${base}/EnviarEmail`, data, false);
    }

    buscarDadosTerminal = () => {
        return super.httpGet(`/${base}/BuscarDadosTerminal`);
    }

    buscarServicos = (data   ) => {
        return super.httpPost(`/${base}/ListarServicos`, data, false);
    }

    buscarServicosVinculados = (data) => {
        return super.httpPost(`/${base}/ServicosVinculados`, data, false);
    }
}

export default new ServicosService();


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/services/ServicosService.js